import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

export const SortableHeader = ({ label, field, sortField, sortDirection, onSort, className = '' }) => {
  const isActive = sortField === field;

  const handleClick = () => {
    if (!isActive) onSort(field, 'asc');
    else if (sortDirection === 'asc') onSort(field, 'desc');
    else onSort(null, null);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1 hover:text-foreground transition-colors whitespace-nowrap ${isActive ? 'text-foreground font-semibold' : ''} ${className}`}
      data-testid={`sort-${field}`}
    >
      {label}
      {isActive ? (
        sortDirection === 'asc'
          ? <ArrowUp className="w-3.5 h-3.5" />
          : <ArrowDown className="w-3.5 h-3.5" />
      ) : (
        <ChevronsUpDown className="w-3.5 h-3.5 opacity-40" />
      )}
    </button>
  );
};

export const applySorting = (data, sortField, sortDirection, getVal) => {
  if (!sortField || !sortDirection) return data;
  return [...data].sort((a, b) => {
    let aVal = getVal ? getVal(a, sortField) : a[sortField];
    let bVal = getVal ? getVal(b, sortField) : b[sortField];
    if (aVal == null) return 1;
    if (bVal == null) return -1;
    if (typeof aVal === 'boolean') { aVal = aVal ? 1 : 0; bVal = bVal ? 1 : 0; }
    if (typeof aVal === 'string') {
      return sortDirection === 'asc'
        ? aVal.localeCompare(bVal, undefined, { sensitivity: 'base' })
        : bVal.localeCompare(aVal, undefined, { sensitivity: 'base' });
    }
    return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
  });
};
